import React from 'react';
import { PROFILE } from '../data/content';
import AudioToggle from './AudioToggle';

export default function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-30 flex items-center justify-between px-5 md:px-10 py-5 pointer-events-none">
      {/* Mobile-only scrim so internally-scrolling section content doesn't collide with the controls */}
      <div className="absolute inset-0 -z-10 md:hidden bg-gradient-to-b from-white/90 via-white/70 to-transparent backdrop-blur-[6px]" aria-hidden="true" />
      <a
        href="#intro"
        data-testid="wordmark"
        className="pointer-events-auto font-display text-lg tracking-tight text-night hover:text-ice transition-colors"
      >
        {PROFILE.name.split(' ')[0]}
        <span className="text-ice">.</span>
      </a>
      <div className="hidden md:flex items-center gap-2 pointer-events-auto">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
        <span className="text-xs tracking-widest2 uppercase text-mist">{PROFILE.availability}</span>
      </div>
      <div className="flex items-center gap-2.5">
        <AudioToggle />
        <a
          href="#contact"
          data-testid="header-contact"
          className="pointer-events-auto text-xs tracking-widest2 uppercase glass rounded-full px-4 py-2 text-night hover:text-ice transition-colors"
        >
          Get in touch
        </a>
      </div>
    </header>
  );
}
